export const getBaseFileName = (url) => {
    if (!url) return '';
    const idx = url.lastIndexOf('/');
    if (idx === -1) return url;
    return url.substring(idx + 1);
};
